<ng-template
  [ngTemplateOutlet]="errorsTemplate() || errorsDefault"
  [ngTemplateOutletContext]="{ $implicit: errors() }" />

<ng-template
  #errorsDefault
  let-errors>
  @for (error of errors; track error.message) {
    <div class="invalid-feedback">
      {{ error.message }}
    </div>
  }
</ng-template>
